import { BlockStack, Box, Divider } from '@shopify/polaris';
import { HeadingColor } from './component/HeadingColor';
import { MethodButton } from './component/MethodButton';
import { CalendarColor } from './component/CalendarColor';
import { TitleColor } from './component/TitleColor';
import { LocalDeliveryChecker } from './component/LocalDeliveryChecker';
import { Message } from './component/Message';
import { CustomCSS } from './component/CustomCSS';
import { ColorPalettes } from './component/ColorPalettes';
import { useSelector } from 'react-redux';
import { widgetAppearanceDisableSelector, widgetSettingSelector } from '@/redux/slice/widget.slice';
import { COLOR_SCHEME_OPTIONS } from '@/constants/enum';

export const WidgetDesignColour = () => {
  const widgetSettings = useSelector(widgetSettingSelector);
  const widgetDisable = useSelector(widgetAppearanceDisableSelector);

  return (
    <BlockStack gap={'300'}>
      <Box
        padding={'300'}
        paddingBlockEnd={
          widgetSettings.colorScheme === COLOR_SCHEME_OPTIONS.CUSTOM || widgetDisable.isDisableCustomStyle ? '0' : '300'
        }
      >
        <ColorPalettes />
      </Box>
      {(widgetSettings.colorScheme === COLOR_SCHEME_OPTIONS.CUSTOM || widgetDisable.isDisableCustomStyle) && (
        <>
          <Divider borderColor="border" />
          <Box padding={'300'} paddingBlock={'0'}>
            <HeadingColor />
          </Box>
          <Divider borderColor="border" />
          <Box padding={'300'} paddingBlock={'0'}>
            <MethodButton />
          </Box>
          <Divider borderColor="border" />
          <Box padding={'300'} paddingBlock={'0'}>
            <CalendarColor />
          </Box>
          <Divider borderColor="border" />
          <Box padding={'300'} paddingBlock={'0'}>
            <TitleColor />
          </Box>
          <Divider borderColor="border" />
          <Box padding={'300'} paddingBlock={'0'}>
            <LocalDeliveryChecker />
          </Box>
          <Divider borderColor="border" />
          <Box padding={'300'} paddingBlock={'0'}>
            <Message />
          </Box>
          <Divider borderColor="border" />
          <Box padding={'300'} paddingBlockStart={'0'}>
            <CustomCSS />
          </Box>
        </>
      )}
    </BlockStack>
  );
};
